<script context="module">
  let user = document.head.querySelector("[name=user]")
  if(user) user = JSON.parse(user.content)
</script>
<script>
  import { onMount } from "svelte"
  import Header from "./Header.svelte"
  import Headline from "./partials/Headline.svelte"
  import Fieldset from './partials/Fieldset.svelte'
  import Button from './partials/Button.svelte'
  import Papa from 'papaparse'
  import Topbar from "./Topbar.svelte"
  import { compareNames, timedAlert } from "../global"

  let loading = true, users = [], selected = false, companies = false, today = new Date(), month = today.getMonth() + 1, day = today.getDate()
  let feedback = {
	style: '',
	msgs: []
  }

  let is_active = 'users'
  let links = []

  today = today.getFullYear() + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day)

  if(user){
	if(user.user_level_id != 3){
	  if(user.user_level_id === 1){
		links.push({
		  id: 'users',
		  slug: 'Users',
		  href: 'users'
		})
	  }
	}
  }
  
  links.push({
	id: 'importer',
	slug: 'Importer',
	href: 'importer'
  },{
	id: 'usage',
	slug: 'Usage',
	href: 'usage'
  })
  
  let secStyle = "px-4 sm:px-6 lg:px-12 py-12 flex flex-col justify-center mx-auto min-h-screen"
  let fStyle = "2xl:max-w-2xl max-w-xl w-full mx-auto text-gray-100 space-y-6"

  function handleSubmit(event){
	loading = true
	let form = event.target.parentNode
	let inputs = form.querySelectorAll('input')
	downloadCsv(inputs, form.id)
  }

  function handleImport(event){
	loading = true
	let form = event.target.parentNode
	let inputs = form.querySelectorAll('input')
	importCsv(inputs[0].files[0])
  }

  function importCsv(file){
	let count = 0, iterations = 0
	let headers = false
	let responses = new Array()
	let token = document.querySelector('meta[name="csrf-token"]')

	Papa.parse(file, {
	  worker: true, 
      step: function(results, parser) {
		count++
		if(count === 1){
		  headers = results.data.map(header => {
			let filtered = header.toLowerCase()
			filtered = filtered.replace(')','')
			filtered = filtered.replace(' (','--')
			filtered = filtered.split(' ').join('_')
			return filtered //First row is always a header
		  })
		  return
		}
		if(results.data.length < 4) return //empty row, footer, tabs

		let entry = {
		  [headers[1]]: results.data[1].replace(/(' '|~|`|!|@|#|$|%|^|&|\*|\(|\)|{|}|\[|\]|;|:|\"|'|<|,|\.|>|\?|\/|\\|\||-|_|\+|=)/g,""),//First Name
		  [headers[2]]: results.data[2].replace(/(' '|~|`|!|@|#|$|%|^|&|\*|\(|\)|{|}|\[|\]|;|:|\"|'|<|,|\.|>|\?|\/|\\|\||-|_|\+|=)/g,""),//Last Name
		  [headers[3]]: results.data[3],//Email
		  company: results.data[39].replace(/(' '|~|`|!|@|#|$|%|^|&|\*|\(|\)|{|}|\[|\]|;|:|\"|'|<|,|\.|>|\?|\/|\\|\||-|_|\+|=)/g,""),//Company
		  [headers[40]]: results.data[40].replace(/(' '|~|`|!|@|#|$|%|^|&|\*|\(|\)|{|}|\[|\]|;|:|\"|'|<|,|\.|>|\?|\/|\\|\||-|_|\+|=)/g,"")//Job Title
		}

		new Promise(function (resolve, reject) {
		  const request = new XMLHttpRequest()

		  request.onreadystatechange = function () {
			let msg = ''
			if (request.readyState !== 4 ) return
			iterations++ 
			if( request.status === 422 ){
			  let response 	= JSON.parse(request.response)
			  let errors 	= Object.values(response.errors)
			  let error_str = ''
			  errors.forEach(error_list => error_list.forEach((error) => error_str += error))

			  reject({message:entry.first_name + ' ' + entry.last_name + ' ran into the following errors:' + error_str})
			} else if (request.status >= 200 && request.status < 300) {
			  users = JSON.parse(request.response)
			  users.sort(compareNames)
			  msg = entry.first_name + ' ' + entry.last_name + ' successfully imported into the database'
			  
			  responses.push({
				text: msg,
				style: 'bg-deep_juniper-50 text-white'
			  })
			  
			  if(iterations === 1){
				timedAlert(() => {
					feedback = {msgs: []}
				}, 360 * count )
			  }
			  
			  feedback = {
				msgs: responses
			  }
			  
			  loading = false

			  resolve()
			} else if( request.status === 500){
			  reject({message:`${entry.first_name + ' ' + entry.last_name} is a duplicate entry`})
			}
		  }

		  request.onerror = function (error) {
			reject({message:"Looks like there are some errors in the CSV!"})
		  }

		  // Setup our HTTP request
		  request.open('POST', '/resource/user', true);
		  request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
		  request.setRequestHeader('X-CSRF-TOKEN', token.content), 
		  request.setRequestHeader('content-type', 'application/json')

		  // Send the request
		  request.send((JSON.stringify(entry)))

		})
		.catch( error => {
		  responses.push(({
			text: error.message,
			style: 'bg-poppy text-white'
		  }))

		  if(responses.length){
			timedAlert()

			feedback = {
			  msgs: responses
			}
		  }
		  loading = false
		})
      },
      complete: function () {
		feedback = {
		  msgs: [{
			text: 'Document has been parsed, let\'s take a look at the entries...',
			style: 'bg-deep_juniper-50 text-white'
		  }]
		}
      }
	})
  }

  function getUsers(callback=false){
	const xhr = new XMLHttpRequest()

	xhr.onload = () => {
	  if (xhr.status == 200) {
	  	loading = false
	    users = JSON.parse(xhr.response)
		users.sort(compareNames)
		selected = users.find(us => us.id === user.id)

		timedAlert(() => {
		  feedback = {msgs: []}
		})

		feedback = {
		  msgs: [{
			text: 'Users successfully loaded!',
			style: 'bg-deep_juniper-50 text-white'
		  }]
		}
		if(callback) callback()
	  } else {
		timedAlert(() => {feedback = {msgs: []}})

		feedback = {
		  msgs: [{
			text: 'Error!',
			style: 'bg-poppy text-white'
		  }]
	    }
	  }
  	}

	xhr.open('GET', '/resource/user')
	xhr.send()
  }

  function changeUser(evt){
	let val = parseInt(evt.target.value)
	selected = users.find(us => us.id === val)
  }

  function updateUser(user, callback=false){
  	const xhr = new XMLHttpRequest()
  	let token = document.querySelector('meta[name="csrf-token"]')

   	xhr.onload = () => {
	  if (xhr.status == 200) {
		loading = false
		users = JSON.parse(xhr.response)
		users.sort(compareNames)
		
		timedAlert(() => {feedback = {msgs: []}})

		feedback = {
		  msgs: [{
			text: user.first_name + ' ' + user.last_name + ' has been updated!',
			style: 'bg-deep_juniper-50 text-white'
		  }]
		}

		if(callback) callback()
	  } else {
		
		timedAlert(() => {feedback = {msgs: []}})

		feedback = {
		  msgs: [{
			text: 'Error!',
		  	style: 'bg-poppy text-white'
		  }]
		}
		if(callback) callback()
	  }
	}

  	xhr.open('PUT', `/resource/user/${user.id}`)
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
	xhr.setRequestHeader('X-CSRF-TOKEN', token.content), 
	xhr.setRequestHeader('content-type', 'application/json')
  	xhr.send(JSON.stringify(user))
  }

  function deleteUser(id){
	const xhr = new XMLHttpRequest()
	let token = document.querySelector('meta[name="csrf-token"]')
	loading = true

	xhr.onload = () => {
	  if (xhr.status == 200) {
	  	loading = false
	  	users = users.filter(us => us.id != id)
		selected = user
		
		timedAlert(() => {feedback = {msgs: []}})
		
		feedback = {
		  msgs: [{
			text: JSON.parse(xhr.responseText),
		  	style: 'bg-deep_juniper-50 text-white'
		  }]
		}
	  } else {
		timedAlert(() => {feedback = {msgs: []}})

	  	feedback = {
		  msgs: [{
			text: 'Error!',
		  	style: 'bg-poppy text-white'
		  }]
	  	}
	  }
    }

	xhr.open('DELETE', `/resource/user/${id}`)
  	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  	xhr.setRequestHeader('X-CSRF-TOKEN', token.content), 
  	xhr.setRequestHeader('content-type', 'application/json')
	xhr.send()
  }

  onMount(() => {
	getUsers()
  })

  //Change from the Story section to the Configurator section
  export function switchSection(event){
	is_active = event.detail.text
  }
  
  // Stolen from: https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
  export const exportToCsv =(filename, rows) => {
    var processRow = function(row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
          var innerValue = row[j] ? row[j].toString() : ''
          var result = innerValue.replace(/"/g, '""')
          if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"'
          if (j > 0) finalVal += ','
          finalVal += result;
      }
      return finalVal + '\n';
    }

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
    }
	loading = false
  }

  export const downloadCsv = (obj, type="registration") => {
    if (obj.length <= 0) return
    let rows = []
	let valid = users.filter(user => {
	  if( new Date(user.created_at) >= new Date(obj[0].value) && user.tracking ) return user
	})
    let th = [
	  'Email', 
	  'First Name', 
	  'Last Name', 
	  'OEM', 
	  'Clicked Video 1', 
	  'Video 1 Watch Time', 
	  'Clicked Video 2', 
	  'Video 2 Watch Time', 
	  'Clicked Video 3', 
	  'Video 3 Watch Time', 
	  'Clicked Video 4', 
	  'Video 4 Watch Time', 
	  'Clicked Video 5', 
	  'Video 5 Watch Time', 
	  'Clicked Configurator']
	rows.push(th)
	valid.forEach(user => {
	  rows.push([
		user.email, 
		user.first_name, 
		user.last_name,
		user.company, 
		user.tracking.view_video__0 === 0 ? '0' : user.tracking.view_video__0,
		user.tracking.time_video__0,
		user.tracking.view_video__1 === 0 ? '0' : user.tracking.view_video__1,
		user.tracking.time_video__1,
		user.tracking.view_video__2 === 0 ? '0' : user.tracking.view_video__2,
		user.tracking.time_video__2,
		user.tracking.view_video__3 === 0 ? '0' : user.tracking.view_video__3,
		user.tracking.time_video__3,
		user.tracking.view_video__4 === 0 ? '0' : user.tracking.view_video__4,
		user.tracking.time_video__4,
		user.tracking.scrollto_configurator === 0 ? '0' : user.tracking.scrollto_configurator,
	  ])
	})
	exportToCsv('pangeaoneness__usage_report.csv', rows)
  }
</script>
<style>
  section {
	scroll-snap-align: center;
	scroll-snap-stop: always;
  }
  [dir="ltr"]{
	scroll-snap-type: y mandatory;
  }
</style>
<Topbar user={user}/>
<Header hStyle="" links={links} is_active={is_active} user={user} home_link={false} on:message={switchSection}/>
<div data-wrapper class="{user.user_level_id === 1 ? 'bg-baltic' : 'bg-deep_juniper'} transition ease-out duration-1000 flex items-center justify-center h-screen bg-cover bg-fixed bg-center" 
 style="background-image:url(img/background__topography.svg)">
 <aside data-feedback class={`fixed bottom-0 left-0 w-screen z-30 text-xs duration-300 transition opacity-100`} style="background-image:url(img/background__topography.svg)">
   {#if feedback.msgs}
   {#each feedback.msgs as msg}
   <p class={`px-4 py-1${msg.style ? ' '+msg.style : ''}`}>{msg.text}</p>
   {/each}
   {/if}
 </aside>
  <div data-container class="relative z-40 flex flex-nowrap flex-col overflow-auto w-full h-screen" dir="ltr"
   on:scroll={evt => {
	let position = evt.target.scrollTop/evt.target.offsetHeight
	if(Number.isInteger(position)) {
	  is_active = links[position].href
	}
   }}>
   	{#if users}
   	  {#if user.user_level_id === 1}
	<section class={secStyle} id="users">
	  <Headline loading={loading} hStyle="" iStyle="2xl:max-w-3xl xl:max-w-lg w-full mx-auto"
	   h1={["User Management","Edit Users"]}/>
	  <form class={fStyle} action="#" on:submit|preventDefault={() => {
		  let newser = {
			id: selected.id,
			first_name: document.getElementById('first_name').value, 
			last_name: document.getElementById('last_name').value, 
			email: selected.email, 
			user_level_id: selected.user_level_id,
			company: document.getElementById('company').value,
			email_verified_at: selected.email_verified_at,
			title: document.getElementById('title').value, 
			tracking_id: selected.tracking_id, 
			created_at: selected.created_at, 
			updated_at: new Date()
		  }
		  updateUser(newser)
		  if(user.id === selected.id){
			let meta = document.head.querySelector("[name=user]")
		  	meta.content = JSON.stringify(newser)
		  }
		}} method="POST">
		<legend class="2xl:max-w-2xl max-w-xl w-full mx-auto text-gray-100 mt-6">
		  <p class="font-body md:text-lg mb-4 md:mb-6 text-sm">Select the user you'd like to modify below</p>
		</legend>
		<div class="flex flex-wrap md:flex-nowrap md:space-x-4">
		  <select on:change={changeUser} id="user" class="font-body bg-shearling hover:border-deep_juniper rounded-none relative block w-full px-3 py-2 border-shearling border border-solid placeholder-gray-400 text-obsidian focus:outline-none focus:ring-deep_juniper focus:border-deep_juniper sm:text-sm">
			{#each users as us}
			<option value={us.id} selected={us.id === selected.id ? true : false}>{us.first_name} {us.last_name}</option>
			{/each}
		  </select>
		  <input type="hidden" value={selected.user_level_id === 1 ? 'Administrator' : (selected.user_level_id === 2 ? 'Manager' : 'Consumer')}/>
		</div>
		<div class="flex flex-wrap md:flex-nowrap md:space-x-4">
		  <Fieldset id="first_name" slug="First Name" dStyle="w-full md:w-1/2" readOnly={loading} value={selected.first_name}/>
		  <Fieldset id="last_name" slug="Last Name" dStyle="w-full md:w-1/2" readOnly={loading} value={selected.last_name}/>
		</div>
		<div class="flex flex-wrap md:flex-nowrap md:space-x-4">
		  <Fieldset id="email" slug="Email" dStyle="w-full" readOnly={true} value={selected.email}/>
		</div>
		<div class="flex flex-wrap md:flex-nowrap md:space-x-4">
		  <Fieldset id="company" slug="Company" dStyle="w-full md:w-1/2" type="text" readOnly={loading} value={selected.company}/>
		  <Fieldset id="title" slug="Job Title" dStyle="w-full md:w-1/2" readOnly={loading} required={false} value={selected.title}/>
		</div>
		<nav class={`max-w-xl 2xl:max-w-2xl w-full mx-auto flex justify-between${loading ? ' hidden pointer-events-none' : ''}`}>
		  {#if selected.user_level_id === 3}
		  <Button slug="Delete" type="button" callback={() => {
			  deleteUser(selected.id)
			}} bStyle="bg-poppy hover:bg-poppy-100 focus:bg-poppy-100 focus:ring-poppy-100"/>
		  {/if}
		  <Button slug="Update"/>
		</nav>
	  </form>
	</section>
	  {/if}
	{/if}
	<section class={secStyle} id="importer">
	  <Headline loading={loading} hStyle="" iStyle="2xl:max-w-3xl xl:max-w-lg w-full mx-auto"
	   h1={["LiveStream Importer","Add Users"]}/>
	  <div class="2xl:max-w-2xl max-w-xl w-full mx-auto text-gray-100 mt-6">
		<p class="font-body md:text-lg mb-4 md:mb-6">Select your .CSV file from the File Upload screen</p>
	  </div>
	  <form class={fStyle} action="#" method="POST" on:submit|preventDefault={handleImport}>
		<div class="flex flex-wrap md:flex-nowrap md:space-x-4">
		  <Fieldset id="file" type="file" slug="File to Import" dStyle="w-full" readOnly={loading} value={null}/>
		</div>
		<nav class={`max-w-xl 2xl:max-w-2xl w-full mx-auto${loading ? ' hidden pointer-events-none' : ''}`}>
		  <Button slug="Start Import"/>
		</nav>
	  </form>
	</section>
	<section class={secStyle} id="usage">
	  <Headline loading={loading} iStyle="2xl:max-w-3xl xl:max-w-lg w-full mx-auto"
	   h1={["Follow-up Report","Active Users"]}/>
	  <div class="2xl:max-w-2xl max-w-xl w-full mx-auto text-gray-100 mt-6">
		<p class="font-body md:text-lg mb-4 md:mb-6">Select a Start and End date, then click "Run" to generate a&nbsp;report</p>
	  </div>
	  <form class={fStyle} action="#" method="POST" on:submit|preventDefault={handleSubmit}>
		<div class="flex flex-wrap md:flex-nowrap md:space-x-4">
		  <Fieldset id="start_date" type="date" slug="Start Date" dStyle="w-full md:w-1/2" readOnly={loading} value="2021-09-01"/>
		  <Fieldset id="end_date" type="date" slug="End Date" dStyle="w-full md:w-1/2" readOnly={loading} value={today}/>
		</div>
		<nav class={`max-w-xl 2xl:max-w-2xl w-full mx-auto${loading ? ' hidden pointer-events-none' : ''}`}>
		  <Button slug="Run Report"/>
		</nav>
	  </form>
	</section>
  </div>
</div>